<template>
    <BreadcrumbsProject
        v-if="$route.meta.layout !== 'deluxe'"
        :breadcrumbs="[
            {
                link : dotNetUrl + '/project/list',
                title : $t('Projects'),
                isRouterLink: false
            },
            {
                link : '/Project/' + projectInfo._id,
                title : (projectInfo.projectNumber || '-') +' ' + (projectInfo.projectName || ''),
                isRouterLink: true
            },
        ]"
    ></BreadcrumbsProject>
    <section
        :class="['project-dashboard-page', {
            'project-dashboard-page--deluxe': $route.meta.layout === 'deluxe'
        }]"
    >
    <div class="project-dashboard-page__tracker">
        <StepItem2
        :deluxe="$route.meta.layout === 'deluxe'"
        :activeIndex="0"
        ></StepItem2>
    </div> 
    <div class="project-dashboard-page__header" >
        <div>
            <h5 class="fw-bold project-dashboard-page__title">{{ $t('Dashboard') }}</h5>
        </div>
        <div class="project-dashboard-page__actions">
                <button class="btn project-dashboard-page__edit-btn me-2" v-if="!editMode" :disabled="savedDashboardLayout === null" @click="()=>{ editMode=!editMode}"><i class="fa-solid fa-pen"></i> {{ $t('Edit') }}</button>
                <button class="btn project-dashboard-page__toolbar-btn project-dashboard-page__toolbar-btn--widgets" data-bs-target="#ModalOpenWidgets" data-bs-toggle="modal" @click="OpenWidgetList"
                v-if="editMode" ><i class="fa-solid fa-object-ungroup"></i> {{ $t('Widget List') }}</button>
                <button class="btn project-dashboard-page__toolbar-btn project-dashboard-page__toolbar-btn--save" :disabled="isWidgetSaving" v-if="editMode" @click="SaveSettings"><i class="fa-solid fa-save"></i>{{ $t('Save Changes') }} </button>

                <!-- <button class="btn btn-primary " v-if="!sharepointFolders.projectSharepointFolders&&sharepointToken" @click="SetUpProject">Set-Up Sharepoint Folders</button> -->
        </div>
    </div>
    <div class="project-dashboard-page__content"  v-if="projectInfo._id"  >
        <Draggable v-model="dashboardSettings.settings"  tag="div" class="project-dashboard-grid"  itemKey="widgetId"
            :animation="150" ghostClass="opacity-50"  handle=".handle" :disabled="!editMode" >
            <template #item="{element}">
                <div v-dashboard-masonry class="project-dashboard-grid__item" :style="{ '--widget-columns': Number(element.width) || 6 }">
                    <div class="top-right-button" v-if="editMode">
                        <button
                            type="button"
                            class="project-dashboard-widget-action project-dashboard-widget-action--settings"
                            title="Change widget size"
                            @click.stop="OpenUpdateWidget(element.widgetId, element.width,element.height)"
                        >
                            <i class="fa-solid fa-gear"></i>
                        </button>
                        <button
                            type="button"
                            class="project-dashboard-widget-action project-dashboard-widget-action--remove"
                            title="Remove widget"
                            @click.stop="RemoveWidget(element.widgetId)"
                        >
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                        <button
                            type="button"
                            class="project-dashboard-widget-action project-dashboard-widget-action--drag handle"
                            title="Drag widget"
                        >
                            <i class="fa-solid fa-bars"></i>
                        </button>
                    </div>
                    <div class="project-dashboard-widget-content">
                        <component :is="element.component" :projectInfo="projectInfo"></component> 
                    </div>
                </div>
            </template>
        </Draggable>
    </div>
    <div v-else class="project-dashboard-page__loading">
        <Loader />
    </div>
    </section>
    <Modal idModal="ModalUpdateWidget" headerTitle="Change Size" modalSize="">
        <div class="widget-size-modal">
            <label class="widget-size-modal__label">Widget Width <span>(required)</span></label>
            <div class="widget-size-modal__choices">
                <button
                    type="button"
                    :class="['widget-size-modal__choice', { 'is-active': Number(updateWidgetObj.width)===3 }]"
                    @click="updateWidgetObj.width=3"
                >
                    25%
                </button>
                <button
                    type="button"
                    :class="['widget-size-modal__choice', { 'is-active': Number(updateWidgetObj.width)===6 }]"
                    @click="updateWidgetObj.width=6"
                >
                    50%
                </button>
                <button
                    type="button"
                    :class="['widget-size-modal__choice', { 'is-active': Number(updateWidgetObj.width)===12 }]"
                    @click="updateWidgetObj.width=12"
                >
                    100%
                </button>
            </div>
            <small class="widget-size-modal__required" v-if="!updateWidgetObj.width">Required</small>
        </div>
        <!-- <div class="form-group">
            <label class="required-style">Widget Height </label>
            <select v-model="updateWidgetObj.height" class="form-select">
                <option value="1">Small</option>
                <option value="2">Regular</option>
                <option value="3">Large</option>
            </select>
            <small class="text-info">INFO : Widget may adjust the chosen height to accommodate content size.</small>
            <small class="text-warning" v-if="!updateWidgetObj.height">Required</small>
        </div> -->
        <template v-slot:actions>
            <button type="button" ref="closeModalUpdateWidget" class="btn widget-size-modal__cancel" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn widget-size-modal__save" @click.stop="UpdateSettings" ><i class="fas fa-save"></i> Save changes</button>
        </template>
    </Modal>
    <Modal idModal="ModalOpenWidgets" headerTitle="Widget List" modalSize="modal-xl" >
        <div class="widget-picker">
            <div class="widget-picker__width">
                <div class="widget-size-modal__label" id="widget-list-width-label">Width for all selected widgets</div>
                <div class="widget-size-modal__choices" role="group" aria-labelledby="widget-list-width-label">
                    <button
                        v-for="choice in [{ value: null, label: 'Keep sizes' }, { value: 3, label: '25%' }, { value: 6, label: '50%' }, { value: 12, label: '100%' }]"
                        :key="String(choice.value)"
                        type="button"
                        :class="['widget-size-modal__choice', { 'is-active': draftWidgetWidth === choice.value }]"
                        :aria-pressed="draftWidgetWidth === choice.value"
                        @click="draftWidgetWidth = choice.value"
                    >{{ choice.label }}</button>
                </div>
            </div>
            <div class="widget-picker__bar">
                <span class="widget-picker__count">{{ draftSelectedWidgets.length }} selected</span>
            </div>
            <div class="widget-picker__grid">
                <button
                    v-for="item in widgetList"
                    :key="item.id"
                    type="button"
                    :class="['widget-picker__item', { 'is-selected': draftSelectedWidgets.indexOf(item.id) > -1 }]"
                    @click="CheckWidget(item.id)"
                >
                    <span class="widget-picker__check">
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span class="widget-picker__label">{{ item.name }}</span>
                </button>
            </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeModalOpenWidgets" class="btn widget-picker__cancel" data-bs-dismiss="modal" @click="CancelWidgetList">Cancel</button>
            <button type="button" class="btn widget-picker__apply" @click="ApplyWidgetList"><i class="fa-solid fa-check"></i> Apply Widgets</button>
        </template>
    </Modal>
    <Modal idModal="BoqModalAdd" headerTitle="Add Bill of Quantity" modalSize="modal-md" v-if="permission.indexOf(ModuleActionList.BOQ_CREATE)>-1">
        <div class="boq-create-modal">
            <div class="boq-create-modal__project">
                <label for="boq-project">Project</label>
                <input
                    id="boq-project"
                    class="form-control"
                    type="text"
                    :value="projectInfo.projectNumber || '-'"
                    disabled
                />
            </div>
            <div class="boq-create-modal__field">
                <label for="boq-name">Name</label>
                <input
                    id="boq-name"
                    v-model="newBoq.name"
                    class="form-control"
                    :class="{ 'is-invalid': boqSaveClicked && !newBoq.name.trim() }"
                    type="text"
                    maxlength="150"
                    placeholder="Enter Name"
                    autocomplete="off"
                    @keyup.enter="CreateBoq"
                />
                <small v-if="boqSaveClicked && !newBoq.name.trim()" class="boq-create-modal__error">
                    Name is required.
                </small>
            </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeAddModal" class="btn boq-create-modal__cancel" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn boq-create-modal__save" :disabled="isExecuting" @click="CreateBoq">
                <i v-if="isExecuting" class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                {{ isExecuting ? 'Creating…' : 'Create' }}
            </button>
        </template>
    </Modal>
    <Modal idModal="BoqModalAddQuotation" headerTitle="Add Quotation" modalSize="modal-md" v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_CREATE)>-1">
        <div class="quotation-modal">
            <div class="quotation-modal__project">
                <label>Project</label>
                <input class="form-control" :value="projectInfo.projectNumber || '-'" disabled />
            </div>
            <div class="quotation-modal__fields">
                <div class="form-group">
                    <label>Quotation No. <span class="quotation-modal__required">(Required)</span></label>
                    <input class="form-control" placeholder="Enter Quotation No." v-model="newQuotation.qtnNumber" />
                    <small class="text-warning" v-if="qtnSaveClicked && !newQuotation.qtnNumber">Required</small>
                </div>
                <div class="form-group">
                    <label>Name <span class="quotation-modal__required">(Required)</span></label>
                    <input class="form-control" placeholder="Enter Name" v-model="newQuotation.qtnName" />
                    <small class="text-warning" v-if="qtnSaveClicked && !newQuotation.qtnName">Required</small>
                </div>
            </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeBoqModalAddQuotation" class="btn quotation-modal__cancel" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn quotation-modal__save" @click="CreateQuotation" >Save and Continue Editing</button>
        </template>
    </Modal>
     <!-- <div class="col-md-4 ">
            <ProjectInformationWidget :projectInfo="projectInfo"  v-if="projectInfo._id"  />
        </div>
        <div class="col-md-4 ">
            <PaymentPositionToVendor :projectInfo="projectInfo" v-if="projectInfo._id" />
            <PaymentPositionToClient :projectInfo="projectInfo" v-if="projectInfo._id" />
            
            <ProjectDates :projectInfo="projectInfo" v-if="projectInfo._id" />
        </div>
        <div class="col-md-4 ">
            <NotificationWidget :projectInfo="projectInfo" v-if="projectInfo._id" />
            <ActionablesWidget :projectInfo="projectInfo" v-if="projectInfo._id" />
            <NetCashPosition :projectInfo="projectInfo"  v-if="projectInfo._id" />
            <TotalTradesProcured :projectInfo="projectInfo"  v-if="projectInfo._id"  />
        </div>
        <div class="col-md-6 ">
            <BillOfQuanitityListWidget :projectInfo="projectInfo" v-if="projectInfo._id" />
        </div>
        <div class="col-md-6 ">
            <ProcurementDetails  :projectInfo="projectInfo"  v-if="projectInfo._id"  />
        </div>
        <div class="col-md-6 ">
            <ProjectQuotationListWidget :projectInfo="projectInfo"  v-if="projectInfo._id"  />
        </div>
        <div class="col-md-4 ">
            <CummulativePaymentPosition :projectInfo="projectInfo"  v-if="projectInfo._id"/>
        </div>
        <div class="col-md-6 ">
            <PurchaseOrdersList :projectInfo="projectInfo"  v-if="projectInfo._id" />
        </div>
        <div class="col-md-6 mt-2 ">
            <DirectoryOverview></DirectoryOverview>
        </div>
        <div class="col-md-12 mt-2 ">
            <ProjectBudgetBreakdown :projectInfo="projectInfo"  v-if="projectInfo._id" />
        </div>
        <div class="col-md-6 mt-2 ">
            <div class="card card-round border">
                <div class="card-body text-center">
                    <h3 class="fw-bold">Budget Spending</h3>
                </div>
            </div>
        </div>
        <div class="col-md-6 mt-2 ">
            <div class="card card-round border">
                <div class="card-body text-center">
                    <h3 class="fw-bold">Forecast</h3>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-2 ">
            <ClientInvoiceList :projectInfo="projectInfo"  v-if="projectInfo._id"  />
        </div>
        <div class="col-md-12 mt-2 ">
            <ClientProgressClaims :projectInfo="projectInfo"  v-if="projectInfo._id"/>
        </div>
        <div class="col-md-12 mt-2 ">
            <ChangeRequestList :projectInfo="projectInfo"  v-if="projectInfo._id" />
        </div> -->
       
        
</template>
<style scoped>
    .project-dashboard-page {
        width: 100%;
    }

    .project-dashboard-page__tracker {
        margin-bottom: 1.5rem;
    }

    .project-dashboard-page__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        margin-bottom: 0.75rem;
    }

    .project-dashboard-page__title {
        margin: 0;
        color: #1e1b16;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 1.5rem;
        line-height: 1.2;
    }

    :global(body.dark h5.project-dashboard-page__title),
    :global(.deluxe-layout.dark h5.project-dashboard-page__title) {
        color: #ffffff !important;
    }

    .project-dashboard-page__actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 0.5rem;
    }

    .project-dashboard-page__actions .btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.4rem;
        border-radius: 0.35rem;
        padding: 0.55rem 0.9rem;
        font-weight: 600;
        line-height: 1.1;
    }

    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn {
        min-width: 8.75rem;
        min-height: 2.5rem;
        border-width: 0;
        border-radius: 0 !important;
        padding: 0.6rem 1.25rem !important;
        font-size: 0.82rem;
        font-weight: 700;
        box-shadow: none !important;
        transition: background-color 0.15s ease, opacity 0.15s ease;
    }

    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn i {
        font-size: 0.9rem;
    }

    .project-dashboard-page__actions .project-dashboard-page__edit-btn,
    .project-dashboard-page__actions .project-dashboard-page__edit-btn:hover,
    .project-dashboard-page__actions .project-dashboard-page__edit-btn:focus,
    .project-dashboard-page__actions .project-dashboard-page__edit-btn:active,
    .project-dashboard-page__actions .project-dashboard-page__edit-btn.active {
        border-color: #ff671f !important;
        color: #ffffff !important;
        background: #ff671f !important;
        box-shadow: none !important;
    }

    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--widgets,
    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--widgets:hover,
    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--widgets:focus,
    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--widgets:active,
    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--widgets.active {
        border-color: #45cf86 !important;
        color: #ffffff !important;
        background: #45cf86 !important;
    }

    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--save,
    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--save:hover,
    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--save:focus,
    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--save:active,
    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn--save.active {
        border-color: #ff671f !important;
        color: #ffffff !important;
        background: #ff671f !important;
    }

    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn:hover,
    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn:focus {
        opacity: 0.88;
    }

    .project-dashboard-page__actions .project-dashboard-page__toolbar-btn:disabled {
        opacity: 0.6;
    }

    .project-dashboard-page__content {
        width: 100%;
    }

    .project-dashboard-grid {
        margin: 0;
        display: grid;
        grid-template-columns: repeat(12, minmax(0, 1fr));
        grid-auto-rows: 1px;
        grid-auto-flow: row dense;
        column-gap: 16px;
        align-items: start;
    }

    .project-dashboard-grid__item {
        min-width: 0;
        position: relative;
        grid-column: span var(--widget-columns, 6);
    }

    .project-dashboard-widget-content {
        display: flow-root;
    }

    @media (max-width: 767.98px) {
        .project-dashboard-grid__item {
            grid-column: span 12;
        }
    }

    .project-dashboard-page__loading {
        display: flex;
        justify-content: center;
        padding: 3rem 0;
    }

    :deep(#ModalUpdateWidget .modal-dialog) {
        max-width: min(31.25rem, calc(100vw - 2rem));
    }

    :deep(#ModalUpdateWidget .modal-content) {
        overflow: hidden;
        border: 0;
        border-radius: 0.18rem;
        background: #ffffff;
        box-shadow: 0 1.35rem 3rem rgba(30, 27, 22, 0.28);
    }

    :deep(#ModalUpdateWidget .modal-header) {
        min-height: 4.25rem;
        border-bottom: 1px solid #e1e6e4;
        padding: 1.2rem 1.45rem;
        background: #ffffff;
    }

    :deep(#ModalUpdateWidget .modal-title) {
        color: #1e1b16;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 1.28rem;
        font-weight: 800;
        line-height: 1.2;
    }

    :deep(#ModalUpdateWidget .btn-close) {
        width: 1.55rem;
        height: 1.55rem;
        margin: 0;
        opacity: 0.65;
        box-shadow: none;
    }

    :deep(#ModalUpdateWidget .modal-body) {
        padding: 1.2rem 1.45rem 1.15rem;
        background: #fbfdfc;
    }

    :deep(#ModalUpdateWidget .modal-footer) {
        display: flex !important;
        justify-content: space-between !important;
        gap: 1rem;
        border-top: 1px solid #e1e6e4;
        padding: 1rem 1.45rem;
        background: #ffffff;
    }

    .widget-size-modal {
        display: flex;
        flex-direction: column;
        gap: 0.7rem;
    }

    .widget-size-modal__label {
        margin: 0;
        color: #1e1b16;
        font-size: 0.84rem;
        font-weight: 800;
        line-height: 1.2;
    }

    .widget-size-modal__label span {
        color: #ff0000;
        font-size: 0.78rem;
    }

    .widget-size-modal__choices {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 0.55rem;
        border: 1px solid #d5e6de;
        border-radius: 0.35rem;
        padding: 0.45rem;
        background: #eef8f4;
    }

    .widget-size-modal__choice {
        display: inline-flex;
        min-height: 2.65rem;
        align-items: center;
        justify-content: center;
        border: 1px solid transparent;
        border-radius: 0.22rem;
        color: #31534a;
        background: #ffffff;
        font-size: 0.95rem;
        font-weight: 800;
        line-height: 1;
        box-shadow: 0 0.18rem 0.45rem rgba(35, 138, 103, 0.08);
        transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
    }

    .widget-size-modal__choice:hover,
    .widget-size-modal__choice:focus {
        border-color: #8ed8bd;
        color: #0f6b51;
        outline: 0;
        transform: translateY(-1px);
    }

    .widget-size-modal__choice.is-active {
        border-color: #238a67;
        color: #ffffff;
        background: #238a67;
        box-shadow: 0 0.35rem 0.9rem rgba(35, 138, 103, 0.2);
    }

    .widget-size-modal__required {
        color: #ff0000;
        font-size: 0.76rem;
        font-weight: 700;
    }

    .widget-size-modal__cancel,
    .widget-size-modal__cancel:hover,
    .widget-size-modal__cancel:focus {
        display: inline-flex;
        min-width: 8rem;
        min-height: 2.45rem;
        align-items: center;
        justify-content: center;
        border: 0 !important;
        border-radius: 0 !important;
        color: #2b2b2b !important;
        background: #dddddd !important;
        font-size: 0.82rem;
        font-weight: 800;
        line-height: 1;
        box-shadow: none !important;
    }

    .widget-size-modal__save,
    .widget-size-modal__save:hover,
    .widget-size-modal__save:focus {
        display: inline-flex;
        min-width: 10rem;
        min-height: 2.45rem;
        align-items: center;
        justify-content: center;
        gap: 0.45rem;
        border: 0 !important;
        border-radius: 0 !important;
        color: #ffffff !important;
        background: #ff5c20 !important;
        font-size: 0.82rem;
        font-weight: 800;
        line-height: 1;
        box-shadow: none !important;
    }

    :deep(#ModalOpenWidgets .modal-dialog) {
        max-width: min(62rem, calc(100vw - 2rem));
    }

    :deep(#ModalOpenWidgets .modal-content) {
        overflow: hidden;
        border: 0;
        border-radius: 0.15rem;
        box-shadow: 0 1.25rem 3rem rgba(30, 27, 22, 0.26);
    }

    :deep(#ModalOpenWidgets .modal-header) {
        min-height: 4rem;
        padding: 1rem 1.35rem;
        border-bottom: 1px solid #e4e8e5;
        background: #ffffff;
    }

    :deep(#ModalOpenWidgets .modal-title) {
        color: #1e1b16;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 1.15rem;
        font-weight: 700;
    }

    :deep(#ModalOpenWidgets .btn-close) {
        width: 2rem;
        height: 2rem;
        margin: 0;
        border-radius: 0;
        box-shadow: none;
    }

    :deep(#ModalOpenWidgets .modal-body) {
        padding: 1rem 1.35rem 1.25rem;
        background: #fbfcfb;
    }

    :deep(#ModalOpenWidgets .modal-footer) {
        min-height: 3.6rem;
        padding: 0.8rem 1.35rem;
        border-top: 1px solid #e4e8e5;
        background: #ffffff;
    }

    :deep(#ModalOpenWidgets .modal-footer .btn) {
        display: inline-flex;
        min-width: 7.5rem;
        min-height: 2.35rem;
        align-items: center;
        justify-content: center;
        gap: 0.4rem;
        border-radius: 0;
        padding: 0.55rem 1rem;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 0.82rem;
        font-weight: 700;
        line-height: 1;
        box-shadow: none !important;
    }

    :deep(#BoqModalAdd .modal-dialog) {
        max-width: min(31rem, calc(100vw - 2rem));
    }

    :deep(#BoqModalAdd .modal-content) {
        overflow: hidden;
        border: 1px solid rgba(215, 121, 66, 0.22);
        border-radius: 0;
        background: #ffffff;
        box-shadow: 0 1.5rem 4rem rgba(38, 26, 20, 0.24);
    }

    :deep(#BoqModalAdd .modal-header) {
        min-height: 4.5rem;
        border-bottom: 1px solid #efd8ca;
        padding: 1.25rem 1.5rem;
        background: linear-gradient(135deg, #fff8f3 0%, #f6dfd2 100%);
    }

    :deep(#BoqModalAdd .modal-title) {
        color: #9d3f12;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 1.25rem;
        font-weight: 800;
        line-height: 1.2;
    }

    :deep(#BoqModalAdd .btn-close) {
        width: 1.7rem;
        height: 1.7rem;
        margin: 0;
        border-radius: 999px;
        opacity: 0.65;
        box-shadow: none;
    }

    :deep(#BoqModalAdd .btn-close:hover) {
        background-color: rgba(182, 77, 22, 0.1);
        opacity: 0.9;
    }

    :deep(#BoqModalAdd .modal-body) {
        padding: 1.35rem 1.5rem 1.5rem;
        background: #ffffff;
    }

    :deep(#BoqModalAdd .modal-footer) {
        display: flex !important;
        min-height: 4.75rem;
        justify-content: space-between !important;
        gap: 0.75rem;
        border-top: 1px solid #eee4de;
        padding: 1rem 1.5rem;
        background: #fffaf7;
    }

    .boq-create-modal {
        color: #2d241f;
        font-family: "Albert Sans", Arial, sans-serif;
    }

    .boq-create-modal__intro {
        display: flex;
        align-items: flex-start;
        gap: 0.9rem;
        margin-bottom: 1.35rem;
    }

    .boq-create-modal__icon {
        display: inline-flex;
        width: 2.8rem;
        height: 2.8rem;
        flex: 0 0 2.8rem;
        align-items: center;
        justify-content: center;
        border-radius: 0;
        color: #b64d16;
        background: #f8e4d7;
        font-size: 1.15rem;
    }

    .boq-create-modal__intro h6 {
        margin: 0 0 0.25rem;
        color: #27201c;
        font-size: 1rem;
        font-weight: 800;
        line-height: 1.3;
    }

    .boq-create-modal__intro p {
        margin: 0;
        color: #6e625c;
        font-size: 0.8rem;
        line-height: 1.45;
    }

    .boq-create-modal__field label {
        display: block;
        margin-bottom: 0.45rem;
        color: #342b26;
        font-size: 0.8rem;
        font-weight: 800;
    }

    .boq-create-modal__field label span {
        color: #c34f18;
        font-size: 0.72rem;
        font-weight: 700;
    }

    .boq-create-modal__input-wrap {
        position: relative;
    }

    .boq-create-modal__input-wrap > i {
        position: absolute;
        top: 50%;
        left: 0.9rem;
        z-index: 1;
        transform: translateY(-50%);
        color: #b76a41;
        font-size: 0.9rem;
        pointer-events: none;
    }

    .boq-create-modal__input-wrap .form-control {
        min-height: 3rem;
        border: 1px solid #d9c9c0;
        border-radius: 0;
        padding: 0.7rem 0.9rem 0.7rem 2.65rem;
        color: #27201c;
        background: #ffffff;
        font-size: 0.88rem;
        box-shadow: none !important;
        transition: border-color 0.15s ease, box-shadow 0.15s ease;
    }

    .boq-create-modal__input-wrap .form-control:focus {
        border-color: #d77942;
        box-shadow: 0 0 0 0.2rem rgba(215, 121, 66, 0.14) !important;
    }

    .boq-create-modal__input-wrap .form-control.is-invalid {
        border-color: #cf3f32;
        background-image: none;
    }

    .boq-create-modal__hint,
    .boq-create-modal__error {
        display: flex;
        align-items: center;
        gap: 0.3rem;
        margin-top: 0.42rem;
        font-size: 0.72rem;
        line-height: 1.3;
    }

    .boq-create-modal__hint {
        color: #81736c;
    }

    .boq-create-modal__error {
        color: #b52d22;
        font-weight: 700;
    }

    .boq-create-modal__cancel,
    .boq-create-modal__save {
        display: inline-flex;
        min-height: 2.65rem;
        align-items: center;
        justify-content: center;
        gap: 0.45rem;
        border-radius: 0 !important;
        padding: 0.65rem 1.25rem !important;
        font-size: 0.82rem;
        font-weight: 800;
        line-height: 1;
        box-shadow: none !important;
    }

    .boq-create-modal__cancel,
    .boq-create-modal__cancel:hover,
    .boq-create-modal__cancel:focus {
        min-width: 6.5rem;
        border: 1px solid #d8ccc5 !important;
        color: #544943 !important;
        background: #ffffff !important;
    }

    .boq-create-modal__save,
    .boq-create-modal__save:hover,
    .boq-create-modal__save:focus {
        min-width: 8.75rem;
        border: 1px solid #c85d24 !important;
        color: #ffffff !important;
        background: #c85d24 !important;
    }

    .boq-create-modal__save:hover:not(:disabled),
    .boq-create-modal__save:focus:not(:disabled) {
        border-color: #a94416 !important;
        background: #a94416 !important;
    }

    .boq-create-modal__save:disabled {
        cursor: wait;
        opacity: 0.68;
    }

    @media (max-width: 575.98px) {
        :deep(#BoqModalAdd .modal-header),
        :deep(#BoqModalAdd .modal-body),
        :deep(#BoqModalAdd .modal-footer) {
            padding-right: 1rem;
            padding-left: 1rem;
        }

        :deep(#BoqModalAdd .modal-footer) {
            flex-direction: column-reverse;
        }

        .boq-create-modal__cancel,
        .boq-create-modal__save {
            width: 100%;
        }
    }

    /* Add BoQ modal follows the simple BOQ-module form layout. */
    :deep(#BoqModalAdd .modal-dialog) {
        max-width: min(21rem, calc(100vw - 2rem));
    }

    :deep(#BoqModalAdd .modal-content) {
        border: 0;
        border-radius: 0;
        box-shadow: 0 1.2rem 3rem rgba(20, 20, 20, 0.26);
    }

    :deep(#BoqModalAdd .modal-header) {
        position: relative;
        justify-content: center;
        min-height: 4.2rem;
        border-bottom: 0;
        padding: 1.25rem 2.75rem 0.75rem;
        background: #ffffff;
    }

    :deep(#BoqModalAdd .modal-title) {
        width: 100%;
        color: #ad4000;
        font-size: 1rem;
        text-align: center;
    }

    :deep(#BoqModalAdd .btn-close) {
        position: absolute;
        top: 0.45rem;
        right: 0.45rem;
        width: 1.55rem;
        height: 1.55rem;
        margin: 0;
        border-radius: 0;
        background-color: transparent;
        opacity: 0.72;
    }

    :deep(#BoqModalAdd .modal-body) {
        padding: 0.2rem 0.75rem 1rem;
    }

    :deep(#BoqModalAdd .modal-footer) {
        min-height: 4.7rem;
        flex-wrap: nowrap;
        padding: 1rem 0.9rem;
        background: #ffffff;
    }

    .boq-create-modal__project {
        margin-bottom: 0.45rem;
    }

    .boq-create-modal__project label,
    .boq-create-modal__field label {
        display: block;
        margin: 0 0 0.35rem;
        color: #161616;
        font-size: 0.68rem;
        font-weight: 800;
        line-height: 1.2;
    }

    .boq-create-modal__project .form-control,
    .boq-create-modal__field .form-control {
        min-height: 1.95rem;
        border: 1px solid #d2d2d2;
        border-radius: 0;
        padding: 0.4rem 0.7rem;
        color: #4b5664;
        background: #ffffff;
        font-size: 0.72rem;
        box-shadow: none !important;
    }

    .boq-create-modal__project .form-control:disabled {
        color: #858d98;
        background: #eeeeee;
        opacity: 1;
    }

    .boq-create-modal__field {
        border: 1px solid #d2d2d2;
        padding: 0.8rem 0.7rem 0.85rem;
        background: #ffffff;
    }

    .boq-create-modal__field .form-control:focus {
        border-color: #b84b0d;
        box-shadow: 0 0 0 0.12rem rgba(184, 75, 13, 0.12) !important;
    }

    .boq-create-modal__field .form-control.is-invalid {
        border-color: #cf3f32;
        background-image: none;
    }

    .boq-create-modal__error {
        margin-top: 0.3rem;
        color: #b52d22;
        font-size: 0.65rem;
        font-weight: 700;
    }

    .boq-create-modal__cancel,
    .boq-create-modal__save {
        min-height: 1.95rem;
        border-radius: 0 !important;
        padding: 0.45rem 0.8rem !important;
        font-size: 0.68rem;
    }

    .boq-create-modal__cancel,
    .boq-create-modal__cancel:hover,
    .boq-create-modal__cancel:focus {
        min-width: 6.1rem;
        border: 0 !important;
        color: #4f4f4f !important;
        background: #dedede !important;
    }

    .boq-create-modal__save,
    .boq-create-modal__save:hover,
    .boq-create-modal__save:focus {
        min-width: 6.1rem;
        border: 0 !important;
        color: #ffffff !important;
        background: #b74400 !important;
    }

    @media (max-width: 575.98px) {
        :deep(#BoqModalAdd .modal-footer) {
            flex-direction: row;
        }

        .boq-create-modal__cancel,
        .boq-create-modal__save {
            width: auto;
        }

    }

    :deep(#BoqModalAddQuotation .modal-dialog) {
        max-width: min(28.75rem, calc(100vw - 2rem));
    }

    :deep(#BoqModalAddQuotation .modal-content) {
        overflow: hidden;
        border: 0;
        border-radius: 0.18rem;
        background: #ffffff;
        box-shadow: 0 1.35rem 3rem rgba(30, 27, 22, 0.28);
    }

    :deep(#BoqModalAddQuotation .modal-header) {
        position: relative;
        justify-content: center;
        min-height: 3.9rem;
        border-bottom: 0;
        padding: 1.2rem 3rem 0.55rem;
        background: #ffffff;
    }

    :deep(#BoqModalAddQuotation .modal-title) {
        width: 100%;
        color: #b0005b;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 1.35rem;
        font-weight: 800;
        line-height: 1.2;
        text-align: center;
    }

    :deep(#BoqModalAddQuotation .btn-close) {
        position: absolute;
        top: 0.8rem;
        right: 0.8rem;
        width: 1.5rem;
        height: 1.5rem;
        margin: 0;
        border-radius: 0;
        opacity: 0.75;
        box-shadow: none;
    }

    :deep(#BoqModalAddQuotation .modal-body) {
        padding: 0.45rem 1.35rem 1.15rem;
        background: #ffffff;
    }

    :deep(#BoqModalAddQuotation .modal-footer) {
        display: flex !important;
        justify-content: space-between !important;
        gap: 0.9rem;
        border-top: 0;
        padding: 0.8rem 1.35rem 1.6rem;
        background: #ffffff;
    }

    .quotation-modal {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        color: #2b2b2b;
        font-family: "Albert Sans", Arial, sans-serif;
    }

    .quotation-modal label {
        display: block;
        margin: 0 0 0.38rem;
        color: #2b2b2b;
        font-size: 0.78rem;
        font-weight: 800;
        line-height: 1.2;
    }

    .quotation-modal__required {
        color: #ff0000;
    }

    .quotation-modal__project .form-control,
    .quotation-modal__fields .form-control {
        min-height: 2.45rem;
        border: 1px solid #cfcfcf;
        border-radius: 0;
        padding: 0.55rem 0.95rem;
        color: #1e1b16;
        background: #ffffff;
        font-size: 0.86rem;
        line-height: 1.2;
        box-shadow: none !important;
    }

    .quotation-modal__project .form-control:disabled {
        color: #8a8a8a;
        background: #eeeeee;
        opacity: 1;
    }

    .quotation-modal__fields {
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        border: 1px solid #cfcfcf;
        border-radius: 0.1rem;
        padding: 0.9rem 0.85rem;
        background: #ffffff;
    }

    .quotation-modal .form-group {
        margin: 0;
    }

    .quotation-modal .text-warning {
        display: block;
        margin-top: 0.25rem;
        color: #b0005b !important;
        font-size: 0.72rem;
        font-weight: 700;
    }

    .quotation-modal__cancel,
    .quotation-modal__cancel:hover,
    .quotation-modal__cancel:focus {
        display: inline-flex;
        min-width: 7.2rem;
        min-height: 2.55rem;
        align-items: center;
        justify-content: center;
        border: 0 !important;
        border-radius: 0 !important;
        color: #2b2b2b !important;
        background: #dddddd !important;
        font-size: 0.82rem;
        font-weight: 800;
        line-height: 1;
        box-shadow: none !important;
    }

    .quotation-modal__save,
    .quotation-modal__save:hover,
    .quotation-modal__save:focus {
        display: inline-flex;
        min-width: 13.2rem;
        min-height: 2.55rem;
        align-items: center;
        justify-content: center;
        border: 0 !important;
        border-radius: 0 !important;
        color: #ffffff !important;
        background: #b0005b !important;
        font-size: 0.82rem;
        font-weight: 800;
        line-height: 1;
        box-shadow: none !important;
    }

    .widget-picker__cancel,
    .widget-picker__cancel:hover,
    .widget-picker__cancel:focus,
    .widget-picker__cancel:active {
        border: 0 !important;
        color: #1e1b16 !important;
        background: #dddddd !important;
    }

    .widget-picker__apply,
    .widget-picker__apply:hover,
    .widget-picker__apply:focus,
    .widget-picker__apply:active {
        border: 0 !important;
        color: #ffffff !important;
        background: #238a67 !important;
    }

    .widget-picker {
        width: 100%;
    }

    .widget-picker__width {
        margin-bottom: 1rem;
    }

    .widget-picker__width .widget-size-modal__choices {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .widget-picker__bar {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0.75rem;
    }

    .widget-picker__count {
        display: inline-flex;
        min-height: 1.7rem;
        align-items: center;
        border: 1px solid #cfe5da;
        padding: 0.25rem 0.65rem;
        color: #0f6b51;
        background: #eefaf4;
        font-size: 0.78rem;
        font-weight: 700;
    }

    .widget-picker__grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0.65rem;
    }

    .widget-picker__item {
        display: grid;
        grid-template-columns: 1.15rem minmax(0, 1fr);
        min-height: 2.65rem;
        align-items: center;
        gap: 0.6rem;
        border: 1px solid #dce3df;
        border-radius: 0;
        padding: 0.55rem 0.75rem;
        color: #1e1b16;
        background: #ffffff;
        text-align: left;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 0.86rem;
        font-weight: 600;
        line-height: 1.2;
        transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;
    }

    .widget-picker__item:hover,
    .widget-picker__item:focus {
        border-color: #79c8aa;
        background: #f3fbf7;
        outline: 0;
    }

    .widget-picker__item.is-selected {
        border-color: #298969;
        color: #063f32;
        background: #e8f7ef;
    }

    .widget-picker__check {
        display: inline-flex;
        width: 1.05rem;
        height: 1.05rem;
        align-items: center;
        justify-content: center;
        border: 1px solid #b8c5bf;
        color: transparent;
        background: #ffffff;
        font-size: 0.62rem;
        line-height: 1;
    }

    .widget-picker__item.is-selected .widget-picker__check {
        border-color: #298969;
        color: #ffffff;
        background: #298969;
    }

    .widget-picker__label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe {
        --dashboard-page-bg: #f4f6f4;
        --dashboard-surface: #ffffff;
        --dashboard-soft: #f7f4f0;
        --dashboard-row: #ffffff;
        --dashboard-row-alt: #fbfcfb;
        --dashboard-row-hover: #f4fbf8;
        --dashboard-border: #dde2df;
        --dashboard-text: #1e1b16;
        --dashboard-muted: #67716c;
        --dashboard-link: #0f6b51;
        --dashboard-widget-header: #e8f7ef;
        --dashboard-widget-heading: #0f6b51;
        --dashboard-table-header: #dff2e9;
        --dashboard-shadow: 0 0.75rem 1.75rem rgba(30, 27, 22, 0.08);
        min-height: 100%;
        border-radius: 0.35rem;
        padding: 1rem;
        background: var(--dashboard-page-bg);
    }

    .project-dashboard-page--deluxe :deep(.alert) {
        min-height: 3.75rem;
        align-items: center;
        border: 0;
        border-radius: 0.35rem !important;
        margin-bottom: 0;
        padding: 1rem 1.1rem !important;
        box-shadow: 0 0.5rem 1.25rem rgba(30, 27, 22, 0.08);
        color: #1e1b16;
        font-family: "Albert Sans", Arial, sans-serif;
        font-weight: 700;
    }

    .project-dashboard-page--deluxe :deep(.alert-warning) {
        border: 1px solid #ffb795 !important;
        background: linear-gradient(135deg, #fff4ef 0%, #ffe3d7 100%);
        color: #27140c;
    }

    .project-dashboard-page--deluxe :deep(.alert-success) {
        background: linear-gradient(135deg, #d7f8e7 0%, #bff0d6 100%);
        color: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.alert .badge) {
        min-width: 1.65rem;
        border: 1px solid rgba(30, 27, 22, 0.22) !important;
        background: rgba(255, 255, 255, 0.42) !important;
        color: currentColor;
        font-weight: 700;
    }

    .project-dashboard-page--deluxe :deep(.alert-warning .badge) {
        border-color: #ff6a2a !important;
        background: rgba(255, 106, 42, 0.12) !important;
        color: #a63b12;
    }

    .project-dashboard-page--deluxe :deep(.alert-success .badge) {
        border-color: rgba(255, 255, 255, 0.82) !important;
        background: rgba(255, 255, 255, 0.18) !important;
        color: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.card) {
        height: 100%;
        overflow: hidden;
        border: 1px solid var(--dashboard-border) !important;
        border-radius: 0.35rem !important;
        background: var(--dashboard-surface) !important;
        box-shadow: var(--dashboard-shadow) !important;
    }

    .project-dashboard-page--deluxe :deep(.card-header) {
        display: flex;
        align-items: center;
        min-height: 3rem;
        padding: 0.85rem 1rem !important;
        border-bottom: 1px solid var(--dashboard-border) !important;
        background: var(--dashboard-soft) !important;
        color: #1e1b16 !important;
    }

    .project-dashboard-page--deluxe :deep(.card-header h6),
    .project-dashboard-page--deluxe :deep(.card-header small) {
        color: inherit !important;
        font-family: "Albert Sans", Arial, sans-serif;
        letter-spacing: 0;
    }

    .project-dashboard-page--deluxe :deep(.card-header i) {
        color: var(--lens-accent);
        margin-right: 0.35rem;
    }

    .project-dashboard-page--deluxe :deep(.card-body) {
        padding: 1rem !important;
        background: var(--dashboard-surface) !important;
        color: #1e1b16 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body.p-0) {
        padding: 0.85rem !important;
        background: #ffffff !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .table-responsive) {
        overflow-x: auto;
        border: 1px solid var(--dashboard-border);
        border-radius: 0.25rem;
        background: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.card-body .border.rounded),
    .project-dashboard-page--deluxe :deep(.card-body .border.rounded-3) {
        border-color: var(--dashboard-border) !important;
        background: #fbfcfb;
    }

    body.dark .project-dashboard-page--deluxe :deep(.card-body),
    body.dark .project-dashboard-page--deluxe :deep(.card-body h4),
    body.dark .project-dashboard-page--deluxe :deep(.card-body h5),
    body.dark .project-dashboard-page--deluxe :deep(.card-body h6),
    body.dark .project-dashboard-page--deluxe :deep(.card-body .border.rounded),
    body.dark .project-dashboard-page--deluxe :deep(.card-body .border.rounded *),
    body.dark .project-dashboard-page--deluxe :deep(.card-body .border.rounded-3),
    body.dark .project-dashboard-page--deluxe :deep(.card-body .border.rounded-3 *),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body h4),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body h5),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body h6),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body .border.rounded),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body .border.rounded *),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body .border.rounded-3),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body .border.rounded-3 *) {
        color: #1e1b16 !important;
    }

    .project-dashboard-page--deluxe :deep(.progress) {
        height: 0.7rem;
        overflow: hidden;
        border-radius: 999px;
        background: #e8eeeb;
    }

    .project-dashboard-page--deluxe :deep(.progress-bar.bg-success) {
        background-color: #2bbf7a !important;
    }

    .project-dashboard-page--deluxe :deep(.progress-bar.bg-info) {
        background-color: #1aa7d8 !important;
    }

    .project-dashboard-page--deluxe :deep(.btn-link) {
        color: var(--lens-accent);
        font-weight: 700;
        text-decoration: none;
    }

    .project-dashboard-page--deluxe :deep(.btn-link:hover) {
        color: var(--lens-accent-dark);
        text-decoration: underline;
    }

    .project-dashboard-page--deluxe :deep(.table) {
        margin-bottom: 0;
        border-collapse: collapse;
        color: #1e1b16;
        background: #ffffff;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 0.86rem;
    }

    .project-dashboard-page--deluxe :deep(.table th) {
        background: var(--dashboard-soft);
        color: #1e1b16;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 0.78rem;
        font-weight: 800;
    }

    .project-dashboard-page--deluxe :deep(.table td),
    .project-dashboard-page--deluxe :deep(.table th) {
        border-color: var(--dashboard-border);
        padding: 0.75rem 0.85rem;
        vertical-align: middle;
    }

    .project-dashboard-page--deluxe :deep(.table tbody tr > *) {
        background: var(--dashboard-row) !important;
        color: #1e1b16 !important;
        box-shadow: none !important;
    }

    .project-dashboard-page--deluxe :deep(.table-striped tbody tr:nth-of-type(even) > *),
    .project-dashboard-page--deluxe :deep(.table tbody tr:nth-child(even) > *) {
        background: var(--dashboard-row-alt) !important;
    }

    .project-dashboard-page--deluxe :deep(.table tbody tr:hover > *) {
        background: var(--dashboard-row-hover) !important;
    }

    .project-dashboard-page--deluxe :deep(.table a) {
        color: #007bff !important;
        text-decoration-thickness: 1px;
        text-underline-offset: 2px;
    }

    body.dark .project-dashboard-page--deluxe :deep(.table tbody td),
    body.dark .project-dashboard-page--deluxe :deep(.table tbody th),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.table tbody td),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.table tbody th) {
        background: var(--dashboard-row) !important;
        color: #1e1b16 !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.table tbody tr:nth-child(even) td),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.table tbody tr:nth-child(even) td) {
        background: var(--dashboard-row-alt) !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.table tbody a),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.table tbody a) {
        color: #007bff !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.card-body .table),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body .table) {
        --bs-table-bg: var(--dashboard-row);
        --bs-table-striped-bg: var(--dashboard-row-alt);
        --bs-table-hover-bg: var(--dashboard-row-hover);
        --bs-table-color: #1e1b16;
        --bs-table-striped-color: #1e1b16;
        --bs-table-hover-color: #1e1b16;
        background-color: #ffffff !important;
        color: #1e1b16 !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.card-body .table > :not(caption) > * > *),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body .table > :not(caption) > * > *) {
        border-color: var(--dashboard-border) !important;
        background-color: #ffffff !important;
        color: #1e1b16 !important;
        box-shadow: none !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.card-body .table tbody tr:nth-child(even) > *),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body .table tbody tr:nth-child(even) > *) {
        background-color: var(--dashboard-row-alt) !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.card-body .table-hover tbody tr:hover > *),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body .table-hover tbody tr:hover > *) {
        background-color: var(--dashboard-row-hover) !important;
        color: #1e1b16 !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.card-body .table a),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.card-body .table a) {
        color: #007bff !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget) {
        --widget-accent: #238a67;
        --widget-accent-dark: #0f6b51;
        --widget-accent-soft: #e8f7ef;
        --widget-accent-line: #bfe6d6;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--quotation) {
        --widget-accent: #b0005b;
        --widget-accent-dark: #7e0041;
        --widget-accent-soft: #fbeaf3;
        --widget-accent-line: #f1bfd7;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--directory),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--procurement),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--project),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--change-request) {
        --widget-accent: #238a67;
        --widget-accent-dark: #0f6b51;
        --widget-accent-soft: #e8f7ef;
        --widget-accent-line: #bfe6d6;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq) {
        --widget-accent: #c35b20;
        --widget-accent-dark: #9a4314;
        --widget-accent-soft: #f2d6c7;
        --widget-accent-line: #dc8a55;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--procurement) {
        --widget-accent: #ae8f00;
        --widget-accent-dark: #8f7600;
        --widget-accent-soft: #f4edc8;
        --widget-accent-line: #d4b52c;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim) {
        --widget-accent: #5617c3;
        --widget-accent-dark: #3f0d9a;
        --widget-accent-soft: #f0eafb;
        --widget-accent-line: #5617c3;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log) {
        --widget-accent: #004aad;
        --widget-accent-dark: #00337c;
        --widget-accent-soft: #e9f0fa;
        --widget-accent-line: #004aad;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log) {
        --widget-accent: #b0008a;
        --widget-accent-dark: #830064;
        --widget-accent-soft: #f7e8f5;
        --widget-accent-line: #b0008a;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--change-request) {
        --widget-accent: #6d0075;
        --widget-accent-dark: #520058;
        --widget-accent-soft: #f3e3f2;
        --widget-accent-line: #6d0075;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--project-information) {
        --widget-accent: #238a67;
        --widget-accent-dark: #0f6b51;
        --widget-accent-soft: #e7f5ef;
        --widget-accent-line: #bfe6d6;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--cumulative-payment) {
        --widget-accent: #238a67;
        --widget-accent-dark: #0f6b51;
        --widget-accent-soft: #e7f5ef;
        --widget-accent-line: #bfe6d6;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule) {
        --widget-accent: #ff5c20;
        --widget-accent-dark: #d94a16;
        --widget-accent-soft: #fff0ea;
        --widget-accent-line: #ffb493;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--net-cash) {
        --widget-accent: #ff5c20;
        --widget-accent-dark: #d94a16;
        --widget-accent-soft: #fff0ea;
        --widget-accent-line: #ffb493;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--directory > .card-header),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--project-overview > .card-header),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--project-information > .card-header),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--cumulative-payment > .card-header) {
        border-bottom-color: var(--widget-accent-line) !important;
        background: var(--widget-accent-soft) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--quotation > .card-header) {
        border-bottom-color: #c5468d !important;
        background: #edd1df !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--directory .table th) {
        border-bottom: 2px solid #238a67 !important;
        color: #0f6b51 !important;
        background: #e8f7ef !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--cumulative-payment .card-body) {
        background: #ffffff !important;
    }

    .project-dashboard-page--deluxe :deep(.cumulative-payment__grid) {
        display: grid;
        grid-template-columns: repeat(4, minmax(8.5rem, 1fr));
        gap: 0.65rem;
    }

    .project-dashboard-page--deluxe :deep(.cumulative-payment__card) {
        display: flex;
        min-height: 4.25rem;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.35rem;
        border: 1px solid #d8e8df;
        border-radius: 0.25rem;
        padding: 0.75rem 0.85rem;
        background: #ffffff;
        text-align: center;
    }

    .project-dashboard-page--deluxe :deep(.cumulative-payment__card--total) {
        grid-column: span 2;
        background: #f4fbf8;
    }

    .project-dashboard-page--deluxe :deep(.cumulative-payment__card span) {
        color: #53635d;
        font-size: 0.82rem;
        font-weight: 700;
        line-height: 1.2;
    }

    .project-dashboard-page--deluxe :deep(.cumulative-payment__card strong) {
        color: #1e1b16;
        font-size: 1.05rem;
        font-weight: 800;
        line-height: 1.2;
        letter-spacing: 0;
    }

    .project-dashboard-page--deluxe :deep(.cumulative-payment__card--paid strong),
    .project-dashboard-page--deluxe :deep(.cumulative-payment__card--approved strong),
    .project-dashboard-page--deluxe :deep(.cumulative-payment__card--pending strong),
    .project-dashboard-page--deluxe :deep(.cumulative-payment__card--to-invoice strong) {
        color: #008ce3;
    }

    .project-dashboard-page--deluxe :deep(.cumulative-payment__card--contract strong) {
        color: #2fbe71;
    }

    .project-dashboard-page--deluxe :deep(.cumulative-payment__card--variation strong) {
        color: #ffad0a;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--project-information .table) {
        border-collapse: collapse;
        border-top: 1px solid #d8e8df;
        border-bottom: 3px solid #d8e8df;
        background: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--project-information .table tbody tr > *) {
        border-color: #d8e8df !important;
        background: #ffffff !important;
        color: #1e1b16 !important;
        padding: 0.85rem 1rem;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--project-information .table tbody tr:nth-child(odd) > *) {
        background: #f4fbf8 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--project-information .table tbody tr > :first-child) {
        width: 38%;
        color: #0f6b51 !important;
        font-weight: 800;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--project-information .table tbody tr > :last-child) {
        color: #27352f !important;
        font-weight: 600;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--project-information .table tbody tr:hover > *) {
        background: #eaf7f1 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq > .card-header) {
        border-bottom-color: #e0a27c !important;
        background: #f6dfd2 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--budget-breakdown > .card-header) {
        border-bottom-color: #dde2df !important;
        background: #ffffff !important;
        color: #1e1b16 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--budget-breakdown .dashboard-widget__title),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--budget-breakdown .dashboard-widget__icon) {
        color: #1e1b16 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--budget-breakdown .card-body) {
        padding: 1.1rem 1rem 1.35rem !important;
        background: #ffffff !important;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__content) {
        display: flex;
        min-height: 22rem;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1.25rem;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__chart-wrap) {
        position: relative;
        width: min(15rem, 72%);
        aspect-ratio: 1;
        margin-top: 0.35rem;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__chart-wrap canvas) {
        max-width: 100%;
        max-height: 100%;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__center-label) {
        position: absolute;
        inset: 50% auto auto 50%;
        display: flex;
        width: 8rem;
        transform: translate(-50%, -50%);
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
        color: #1e1b16;
        text-align: center;
        pointer-events: none;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__center-label strong) {
        color: #1e1b16;
        font-size: 0.92rem;
        font-weight: 800;
        line-height: 1.15;
        letter-spacing: 0;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__center-label span) {
        color: #1e1b16;
        font-size: 0.68rem;
        font-weight: 700;
        line-height: 1.15;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__legend) {
        display: grid;
        width: min(28rem, 100%);
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0.75rem 1.4rem;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__legend-item) {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr) auto;
        align-items: center;
        gap: 0.45rem;
        color: #1e1b16;
        font-size: 0.78rem;
        font-weight: 700;
        line-height: 1.2;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__dot) {
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 999px;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__name) {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe :deep(.budget-breakdown__percent) {
        color: #1e1b16;
        font-weight: 800;
        white-space: nowrap;
    }

    @media (max-width: 575.98px) {
        .project-dashboard-page--deluxe :deep(.budget-breakdown__legend) {
            grid-template-columns: 1fr;
        }
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--procurement > .card-header) {
        border-bottom-color: #d4b52c !important;
        background: #f4edc8 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--change-request > .card-header) {
        border-bottom-color: #6d0075 !important;
        background: #e7ccd9 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .table-responsive) {
        border-color: #e0a27c;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .table th) {
        border-bottom: 2px solid #d77942;
        color: #b64d16;
        background: #f1d3c2;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .table tbody tr > *) {
        background: #f7f3f1 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .table-striped tbody tr:nth-of-type(even) > *),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .table tbody tr:nth-child(even) > *) {
        background: #ddd8d4 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .table tbody tr:hover > *) {
        background: #f1e5df !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .table a) {
        color: #1e2b7a !important;
        font-weight: 800;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .badge) {
        border-radius: 999px;
        padding: 0.35rem 0.75rem;
        font-size: 0.72rem;
        font-weight: 800;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .badge.bg-primary),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--boq .badge.bg-info) {
        color: #a45b00 !important;
        background: #ffe28a !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim > .card-header) {
        border-bottom-color: #c9b8ec !important;
        background: #f0eafb !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log > .card-header) {
        border-bottom-color: #004aad !important;
        background: #c8d8ee !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .dashboard-widget__title),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .dashboard-widget__icon) {
        color: #004aad !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table) {
        border-collapse: collapse;
        border-bottom: 4px solid #b5b5b5;
        background: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table thead th) {
        border-bottom: 2px solid #004aad !important;
        border-color: #cbd7e8 !important;
        background: #c8d8ee !important;
        color: #004aad !important;
        font-weight: 800;
        text-align: center;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table tbody tr > *) {
        border-color: #d2dbe8 !important;
        background: #ffffff !important;
        color: #0f172a !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table tbody tr > :nth-child(1)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table tbody tr > :nth-child(3)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table tbody tr > :nth-child(5)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table tbody tr > :nth-child(7)) {
        background: #edf3fa !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table-striped tbody tr:nth-of-type(even) > *) {
        background: #f0f0f0 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table-striped tbody tr:nth-of-type(even) > :nth-child(1)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table-striped tbody tr:nth-of-type(even) > :nth-child(3)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table-striped tbody tr:nth-of-type(even) > :nth-child(5)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table-striped tbody tr:nth-of-type(even) > :nth-child(7)) {
        background: #e3ebf5 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table tbody tr:hover > *) {
        background: #e9f1fb !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table a) {
        color: #004aad !important;
        font-weight: 700;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table td span[class*="text-"]) {
        display: inline-flex;
        min-height: 1.5rem;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
        padding: 0.25rem 0.75rem;
        font-size: 0.76rem;
        font-weight: 800;
        line-height: 1;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table td span.text-success) {
        color: #008372 !important;
        background: #cfe7e4;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table td span.text-primary) {
        color: #005da8 !important;
        background: #cfe6fb;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table td span.text-warning) {
        color: #c26400 !important;
        background: #ffe6a3;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .table td span.text-muted) {
        color: #6b7280 !important;
        background: #e5e7eb;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .dashboard-widget__link) {
        color: #004aad !important;
        background: #e9f0fa;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .dashboard-widget__link:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--client-invoice-log .dashboard-widget__link:focus) {
        border-color: #b7c9e3;
        color: #00337c !important;
        background: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log > .card-header) {
        border-bottom-color: #b0008a !important;
        background: #e8c2e5 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .dashboard-widget__title),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .dashboard-widget__icon) {
        color: #b0008a !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table) {
        border-collapse: collapse;
        min-width: 58rem;
        border-bottom: 4px solid #b5b0b5;
        background: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .purchase-order-log__table-scroll) {
        overflow-x: auto;
        overflow-y: hidden;
        padding: 0.85rem 0.85rem 0;
        background: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .purchase-order-log__table-scroll::-webkit-scrollbar) {
        height: 0.55rem;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .purchase-order-log__table-scroll::-webkit-scrollbar-track) {
        background: #f3e7f1;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .purchase-order-log__table-scroll::-webkit-scrollbar-thumb) {
        border-radius: 999px;
        background: #d6abd0;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table thead th) {
        border-bottom: 2px solid #b0008a !important;
        border-color: #d8c7d6 !important;
        background: #e8c2e5 !important;
        color: #a0007c !important;
        font-weight: 800;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table th:nth-child(1)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td:nth-child(1)) {
        width: 3rem;
        min-width: 3rem;
        text-align: center;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table th:nth-child(2)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td:nth-child(2)) {
        min-width: 11rem;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table th:nth-child(3)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td:nth-child(3)) {
        min-width: 10rem;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table th:nth-child(4)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td:nth-child(4)) {
        min-width: 14rem;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table th:nth-child(5)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td:nth-child(5)) {
        min-width: 8.5rem;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table th:nth-child(6)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td:nth-child(6)) {
        min-width: 11rem;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table th:nth-child(7)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td:nth-child(7)) {
        min-width: 8rem;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table tbody tr > *) {
        border-color: #ddd4dd !important;
        background: #ffffff !important;
        color: #111827 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table tbody tr > :nth-child(1)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table tbody tr > :nth-child(3)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table tbody tr > :nth-child(5)) {
        background: #f5edf5 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table-striped tbody tr:nth-of-type(even) > *) {
        background: #d9d5d9 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table-striped tbody tr:nth-of-type(even) > :nth-child(1)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table-striped tbody tr:nth-of-type(even) > :nth-child(3)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table-striped tbody tr:nth-of-type(even) > :nth-child(5)) {
        background: #cec8ce !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table tbody tr:hover > *) {
        background: #f1e5f0 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table a) {
        color: #004aad !important;
        font-weight: 700;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td .purchase-order-status) {
        display: inline-flex;
        min-height: 1.5rem;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
        padding: 0.25rem 0.75rem;
        color: #008372 !important;
        background: #cfe7e4;
        font-size: 0.76rem;
        font-weight: 800;
        line-height: 1;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td .purchase-order-status--rejected) {
        color: #c40000 !important;
        background: #efc0ca !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td span.text-warning) {
        color: #c26400 !important;
        background: #ffe6a3;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td span.text-muted) {
        color: #6b7280 !important;
        background: #e5e7eb;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td span.text-info),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .table td span.text-primary) {
        color: #005da8 !important;
        background: #cfe6fb;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .dashboard-widget__link) {
        color: #b0008a !important;
        background: #f7e8f5;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .dashboard-widget__link:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--purchase-order-log .dashboard-widget__link:focus) {
        border-color: #e2bddc;
        color: #830064 !important;
        background: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule > .card-header) {
        border-bottom-color: #ff5c20 !important;
        background: #ff5c20 !important;
        color: #ffffff !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--net-cash > .card-header) {
        border-bottom-color: #ff5c20 !important;
        background: #ff5c20 !important;
        color: #ffffff !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule .dashboard-widget__title),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule .dashboard-widget__icon),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--net-cash .dashboard-widget__title),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--net-cash .dashboard-widget__icon) {
        color: #ffffff !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule .table) {
        overflow: hidden;
        border: 1px solid #f2cbbb;
        border-radius: 0.3rem;
        background: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule .table tbody tr > *) {
        border-color: #f2d8cd !important;
        background: #ffffff !important;
        color: #1e1b16 !important;
        padding-block: 0.85rem;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule .table tbody tr:nth-child(1) > *),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule .table tbody tr:nth-child(3) > *) {
        background: #fff6f1 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule .table tbody tr > td[rowspan]) {
        min-width: 11rem;
        background: #fff0e8 !important;
        color: #6b2f19 !important;
        font-size: 0.86rem;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule .table tbody tr > .fw-bold) {
        color: #6b2f19 !important;
        font-weight: 800 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--schedule .table tbody tr:hover > *) {
        background: #fff8f4 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--net-cash .card-body) {
        display: flex;
        min-height: 4.25rem;
        align-items: center;
        justify-content: center;
        border-top: 0;
        background: #fff4ee !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--net-cash h4) {
        margin: 0;
        color: #5f2612 !important;
        font-size: 1.35rem;
        font-weight: 800;
        letter-spacing: 0;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table th) {
        border-bottom: 2px solid #5617c3;
        color: #4b10b5;
        background: #d9cdf2;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table tbody tr > *) {
        background: #ffffff !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table tbody tr > :nth-child(1)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table tbody tr > :nth-child(3)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table tbody tr > :nth-child(5)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table tbody tr > :nth-child(7)) {
        background: #f0edf9 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table-striped tbody tr:nth-of-type(even) > *) {
        background: #dedede !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table-striped tbody tr:nth-of-type(even) > :nth-child(1)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table-striped tbody tr:nth-of-type(even) > :nth-child(3)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table-striped tbody tr:nth-of-type(even) > :nth-child(5)),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table-striped tbody tr:nth-of-type(even) > :nth-child(7)) {
        background: #d5d2dc !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table tbody tr:hover > *) {
        background: #eee7fb !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table a) {
        color: #5617c3 !important;
        font-weight: 800;
    }

    .project-dashboard-page :deep(.dashboard-widget .table a:not(.btn):not(.dashboard-widget__button):not(.dashboard-widget__link)),
    .project-dashboard-page :deep(.dashboard-widget .table a:not(.btn):not(.dashboard-widget__button):not(.dashboard-widget__link):hover),
    .project-dashboard-page :deep(.dashboard-widget .table a:not(.btn):not(.dashboard-widget__button):not(.dashboard-widget__link):focus) {
        color: #007bff !important;
        text-decoration: none !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table td span[class*="text-"]) {
        display: inline-flex;
        min-height: 1.55rem;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
        padding: 0.25rem 0.8rem;
        font-size: 0.76rem;
        font-weight: 800;
        line-height: 1;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table td span.text-success) {
        color: #008372 !important;
        background: #cfe7e4;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table td span.text-primary) {
        color: #005da8 !important;
        background: #cfe6fb;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table td span.text-warning) {
        color: #c26400 !important;
        background: #ffe6a3;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--progress-claim .table td span.text-muted) {
        color: #6b6376 !important;
        background: #e7e3ee;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--vendor-payment > .card-header) {
        border-bottom-color: #bce8e8 !important;
        background: #d8f3f3 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__title) {
        display: inline-flex;
        align-items: center;
        gap: 0.55rem;
        min-width: 0;
        color: #1e1b16 !important;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 1rem;
        line-height: 1.2;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__icon) {
        display: inline-flex;
        width: 1.2rem;
        height: 1.2rem;
        flex: 0 0 1.2rem;
        align-items: center;
        justify-content: center;
        color: var(--widget-accent);
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__icon svg) {
        width: 1.2rem;
        height: 1.2rem;
        display: block;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__icon svg *) {
        stroke: currentColor !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--procurement .dashboard-widget__title),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--procurement .dashboard-widget__icon) {
        color: #ae8f00 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--quotation .dashboard-widget__title),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--quotation .dashboard-widget__icon) {
        color: #a00055 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget--change-request .dashboard-widget__title),
    .project-dashboard-page--deluxe :deep(.dashboard-widget--change-request .dashboard-widget__icon) {
        color: #6d0075 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__footer) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.75rem;
        padding: 0.9rem 0.25rem 0.15rem;
        border-top: 1px solid var(--dashboard-border);
        background: #ffffff;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__footer--end) {
        justify-content: flex-end;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__button) {
        display: inline-flex;
        min-height: 2.25rem;
        align-items: center;
        justify-content: center;
        gap: 0.45rem;
        border: 1px solid var(--widget-accent) !important;
        border-radius: 0 !important;
        padding: 0.5rem 1rem !important;
        color: #ffffff !important;
        background: var(--widget-accent) !important;
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 0.82rem;
        font-weight: 700;
        line-height: 1;
        text-decoration: none !important;
        box-shadow: none !important;
        transition: background-color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__button:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget__button:focus) {
        border-color: var(--widget-accent-dark) !important;
        background: var(--widget-accent-dark) !important;
        opacity: 0.94;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__button--secondary) {
        color: var(--widget-accent-dark) !important;
        background: #ffffff !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__button--secondary:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget__button--secondary:focus) {
        color: var(--widget-accent-dark) !important;
        background: var(--widget-accent-soft) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__link) {
        display: inline-flex;
        min-height: 2rem;
        align-items: center;
        justify-content: center;
        border: 1px solid transparent;
        border-radius: 999px;
        padding: 0.3rem 0.75rem;
        color: var(--widget-accent-dark) !important;
        background: var(--widget-accent-soft);
        font-family: "Albert Sans", Arial, sans-serif;
        font-size: 0.82rem;
        font-weight: 700;
        line-height: 1;
        text-decoration: none !important;
        transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__link:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget__link:focus) {
        border-color: var(--widget-accent-line);
        color: var(--widget-accent-dark) !important;
        background: #ffffff;
        text-decoration: none !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__link--center) {
        margin-inline: auto;
    }

    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget__footer),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget__footer) {
        background: #ffffff !important;
        color: #1e1b16 !important;
    }

    /* Keep every dashboard module on the same square, mint-green visual system. */
    .project-dashboard-page--deluxe :deep(.dashboard-widget) {
        --widget-accent: #238a67;
        --widget-accent-dark: #0f6b51;
        --widget-accent-soft: #e8f7ef;
        --widget-accent-line: #bfe6d6;
        overflow: hidden;
        border: 1px solid var(--dashboard-border) !important;
        border-radius: 0 !important;
        background: var(--dashboard-surface) !important;
        box-shadow: 0 0.75rem 1.8rem rgba(24, 79, 62, 0.08) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget > .card-header) {
        border-bottom: 1px solid #238a67 !important;
        border-radius: 0 !important;
        background: var(--dashboard-widget-header) !important;
        color: var(--dashboard-widget-heading) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .dashboard-widget__title),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .dashboard-widget__icon),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .card-header h6),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .card-header i) {
        color: var(--dashboard-widget-heading) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget > .card-body),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .dashboard-widget__footer) {
        border-radius: 0 !important;
        background: var(--dashboard-surface) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget[class*="dashboard-widget--"] .table thead th) {
        border-color: var(--dashboard-border) !important;
        border-bottom: 2px solid #238a67 !important;
        background: var(--dashboard-table-header) !important;
        color: var(--dashboard-widget-heading) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table) {
        border-bottom: 1px solid var(--dashboard-border) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget[class*="dashboard-widget--"] .table tbody tr > :nth-child(n)) {
        border-color: var(--dashboard-border) !important;
        background: var(--dashboard-row) !important;
        color: var(--dashboard-text) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget[class*="dashboard-widget--"] .table-striped tbody tr:nth-of-type(even) > :nth-child(n)) {
        background: var(--dashboard-row-alt) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget[class*="dashboard-widget--"] .table tbody tr:hover > :nth-child(n)) {
        background: var(--dashboard-row-hover) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget[class*="dashboard-widget--"] .table a),
    .project-dashboard-page--deluxe :deep(.dashboard-widget[class*="dashboard-widget--"] .table a:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget[class*="dashboard-widget--"] .table a:focus) {
        color: var(--dashboard-link) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget[class*="dashboard-widget--"] .table a),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget[class*="dashboard-widget--"] .table a:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget[class*="dashboard-widget--"] .table a:focus) {
        color: var(--dashboard-link) !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table tbody tr > .dashboard-widget__empty-state) {
        height: 4rem;
        border-color: #d8e8df !important;
        padding: 1rem !important;
        color: #53635d !important;
        background: #f6fbf8 !important;
        font-size: 0.82rem;
        font-weight: 600;
        line-height: 1.35;
        text-align: center !important;
        vertical-align: middle;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .table .dashboard-widget-table__actions) {
        min-width: 5.5rem;
        text-align: center !important;
        white-space: nowrap;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table .dashboard-widget-table__actions a) {
        display: inline-flex;
        width: 1.75rem;
        height: 1.75rem;
        align-items: center;
        justify-content: center;
        border: 0 !important;
        color: #7b817f !important;
        background: transparent !important;
        font-size: 1rem;
        line-height: 1;
        text-decoration: none !important;
        box-shadow: none !important;
    }

    .project-dashboard-page.project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table .dashboard-widget-table__actions a),
    .project-dashboard-page.project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table .dashboard-widget-table__actions a i) {
        color: #7b817f !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table .dashboard-widget-table__actions a:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table .dashboard-widget-table__actions a:focus) {
        color: #0f6b51 !important;
        background: transparent !important;
        outline: 0;
    }

    .project-dashboard-page.project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table .dashboard-widget-table__actions a:hover),
    .project-dashboard-page.project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table .dashboard-widget-table__actions a:hover i),
    .project-dashboard-page.project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table .dashboard-widget-table__actions a:focus),
    .project-dashboard-page.project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table .dashboard-widget-table__actions a:focus i) {
        color: #0f6b51 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__link),
    .project-dashboard-page--deluxe :deep(.dashboard-widget__button),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .btn) {
        border-color: #238a67 !important;
        border-radius: 0 !important;
        color: #0f6b51 !important;
        background: #e8f7ef !important;
        box-shadow: none !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .dashboard-widget__link),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .dashboard-widget__button),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .btn) {
        border-color: #238a67 !important;
        color: #0f6b51 !important;
        background: #e8f7ef !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget__link:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget__link:active),
    .project-dashboard-page--deluxe :deep(.dashboard-widget__link:focus),
    .project-dashboard-page--deluxe :deep(.dashboard-widget__button:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget__button:active),
    .project-dashboard-page--deluxe :deep(.dashboard-widget__button:focus),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .btn:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .btn:active),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .btn:focus) {
        border-color: #0f6b51 !important;
        color: #ffffff !important;
        background: #0f6b51 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .dashboard-widget__link:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .dashboard-widget__link:active),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .dashboard-widget__link:focus),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .dashboard-widget__button:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .dashboard-widget__button:active),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .dashboard-widget__button:focus),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .btn:hover),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .btn:active),
    .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .btn:focus) {
        border-color: #0f6b51 !important;
        color: #ffffff !important;
        background: #0f6b51 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .table-responsive),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .quotation-widget__table-wrap),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .change-request-widget__table-wrap),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .purchase-order-log__table-scroll),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .client-invoice-list__table-scroll),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .client-progress-claims__table-scroll),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .cumulative-payment__card),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .project-overview-widget__metric-card),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .procurement-widget__metric),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .procurement-widget__progress-track),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .progress),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .alert) {
        border-color: #cfe3da !important;
        border-radius: 0 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .badge),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .table td span[class*="text-"]),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .purchase-order-status),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .quotation-widget-status),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .change-request-widget__status),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .procurement-widget__status) {
        border-radius: 999px !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .table-responsive),
    .project-dashboard-page--deluxe :deep(.dashboard-widget [class*="__table-scroll"]),
    .project-dashboard-page--deluxe :deep(.dashboard-widget [class*="__table-wrap"]),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .project-overview-widget__scroll),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .cumulative-payment__scroll) {
        scrollbar-color: #78ad9b #edf5f2;
        scrollbar-width: thin;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .table-responsive::-webkit-scrollbar),
    .project-dashboard-page--deluxe :deep(.dashboard-widget [class*="__table-scroll"]::-webkit-scrollbar),
    .project-dashboard-page--deluxe :deep(.dashboard-widget [class*="__table-wrap"]::-webkit-scrollbar),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .project-overview-widget__scroll::-webkit-scrollbar),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .cumulative-payment__scroll::-webkit-scrollbar) {
        width: 0.4rem !important;
        height: 0.4rem !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .table-responsive::-webkit-scrollbar-track),
    .project-dashboard-page--deluxe :deep(.dashboard-widget [class*="__table-scroll"]::-webkit-scrollbar-track),
    .project-dashboard-page--deluxe :deep(.dashboard-widget [class*="__table-wrap"]::-webkit-scrollbar-track),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .project-overview-widget__scroll::-webkit-scrollbar-track),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .cumulative-payment__scroll::-webkit-scrollbar-track) {
        background: #edf5f2 !important;
    }

    .project-dashboard-page--deluxe :deep(.dashboard-widget .table-responsive::-webkit-scrollbar-thumb),
    .project-dashboard-page--deluxe :deep(.dashboard-widget [class*="__table-scroll"]::-webkit-scrollbar-thumb),
    .project-dashboard-page--deluxe :deep(.dashboard-widget [class*="__table-wrap"]::-webkit-scrollbar-thumb),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .project-overview-widget__scroll::-webkit-scrollbar-thumb),
    .project-dashboard-page--deluxe :deep(.dashboard-widget .cumulative-payment__scroll::-webkit-scrollbar-thumb) {
        border-radius: 0 !important;
        background: #78ad9b !important;
    }

    @media (max-width: 767.98px) {
        .project-dashboard-page__header {
            align-items: stretch;
            flex-direction: column;
        }

        .project-dashboard-page__actions {
            justify-content: flex-start;
        }

        .project-dashboard-page__actions .btn {
            justify-content: center;
            width: 100%;
        }

        .widget-picker__grid {
            grid-template-columns: 1fr;
        }

        .widget-picker__label {
            white-space: normal;
        }
    }

    .text-delta{
        color: #919092;
    }
    .bg-delta{
        color: #CBD4D8;
    }
    .top-right-button {
        position: absolute;
        top: 0.72rem;
        right: 0.78rem;
        z-index: 500;
        display: inline-flex;
        align-items: center;
        gap: 0.42rem;
        padding: 0;
        border: 0;
        background: transparent;
    }

    .project-dashboard-widget-action {
        display: inline-flex;
        width: 1rem;
        height: 1rem;
        align-items: center;
        justify-content: center;
        border: 0;
        border-radius: 0;
        padding: 0;
        color: #075b4f;
        background: transparent;
        font-size: 0.82rem;
        line-height: 1;
        text-shadow: 0 1px 0 rgba(255, 255, 255, 0.68);
        box-shadow: none;
        transition: color 0.15s ease, transform 0.15s ease;
    }

    .project-dashboard-widget-action--settings {
        color: #075b4f;
    }

    .project-dashboard-widget-action--remove {
        color: #ff3150;
    }

    .project-dashboard-widget-action--drag {
        color: #006e9f;
        cursor: grab;
    }

    .project-dashboard-widget-action--drag:active {
        cursor: grabbing;
    }

    .project-dashboard-widget-action:hover,
    .project-dashboard-widget-action:focus {
        background: transparent;
        outline: 0;
        box-shadow: none;
        transform: scale(1.15);
    }

    .project-dashboard-widget-action--settings:hover,
    .project-dashboard-widget-action--settings:focus {
        color: #043f36;
    }

    .project-dashboard-widget-action--remove:hover,
    .project-dashboard-widget-action--remove:focus {
        color: #e60025;
    }

    .project-dashboard-widget-action--drag:hover,
    .project-dashboard-widget-action--drag:focus {
        color: #004c7a;
    }

    body.dark .project-dashboard-page--deluxe,
    .deluxe-layout.dark .project-dashboard-page--deluxe {
        --dashboard-page-bg: #111827;
        --dashboard-surface: #1a2433;
        --dashboard-soft: #203346;
        --dashboard-row: #1a2433;
        --dashboard-row-alt: #202c3d;
        --dashboard-row-hover: #2b4550;
        --dashboard-border: #3b5368;
        --dashboard-text: #f5f7fa;
        --dashboard-muted: #c2ccd6;
        --dashboard-link: #80d9b5;
        --dashboard-widget-header: #1d3b42;
        --dashboard-widget-heading: #96e2c0;
        --dashboard-table-header: #1d3b42;
        --dashboard-shadow: 0 0.75rem 1.75rem rgba(0, 0, 0, 0.24);
        background: var(--dashboard-page-bg);
        color: var(--dashboard-text);
    }

    body.dark .project-dashboard-page--deluxe .project-dashboard-page__title,
    .deluxe-layout.dark .project-dashboard-page--deluxe .project-dashboard-page__title {
        color: var(--dashboard-text) !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget) {
        border-color: var(--dashboard-border) !important;
        background: var(--dashboard-surface) !important;
        color: var(--dashboard-text) !important;
        box-shadow: var(--dashboard-shadow) !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget > .card-header),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget > .card-header) {
        border-color: #298969 !important;
        background: var(--dashboard-widget-header) !important;
        color: var(--dashboard-widget-heading) !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget > .card-body),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .dashboard-widget__footer),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget > .card-body),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .dashboard-widget__footer) {
        border-color: var(--dashboard-border) !important;
        background: var(--dashboard-surface) !important;
        color: var(--dashboard-text) !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .project-overview-widget__metric-card),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .procurement-widget__metric),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .cumulative-payment__card),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .table-responsive),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .project-overview-widget__metric-card),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .procurement-widget__metric),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .cumulative-payment__card),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .table-responsive) {
        border-color: var(--dashboard-border) !important;
        background: var(--dashboard-row) !important;
        color: var(--dashboard-text) !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h1),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h2),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h3),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h4),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h5),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h6),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body p),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body label),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body small),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h1),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h2),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h3),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h4),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h5),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body h6),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body p),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body label),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .card-body small) {
        color: inherit;
    }

    body.dark .project-dashboard-page--deluxe :deep(.project-overview-widget__value),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget--project-overview .card-body h6.project-overview-widget__label),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget--net-cash h4),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.project-overview-widget__value),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget--project-overview .card-body h6.project-overview-widget__label),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget--net-cash h4) {
        color: var(--dashboard-text) !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__legend),
    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__legend span),
    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__metric strong),
    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__metric span),
    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__metric small),
    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__progress-label),
    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__progress-label span),
    body.dark .project-dashboard-page--deluxe :deep(.cumulative-payment__card > span),
    body.dark .project-dashboard-page--deluxe :deep(.cumulative-payment__card--total strong),
    body.dark .project-dashboard-page--deluxe :deep(.budget-breakdown__center-label strong),
    body.dark .project-dashboard-page--deluxe :deep(.budget-breakdown__center-label span),
    body.dark .project-dashboard-page--deluxe :deep(.budget-breakdown__name),
    body.dark .project-dashboard-page--deluxe :deep(.budget-breakdown__percent),
    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__name),
    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__date),
    body.dark .project-dashboard-page--deluxe :deep(.procurement-widget__round),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__legend),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__legend span),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__metric strong),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__metric span),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__metric small),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__progress-label),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__progress-label span),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.cumulative-payment__card > span),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.cumulative-payment__card--total strong),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.budget-breakdown__center-label strong),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.budget-breakdown__center-label span),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.budget-breakdown__name),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.budget-breakdown__percent),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__name),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__date),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.procurement-widget__round) {
        color: #e2e8f0 !important;
    }
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget[class*="dashboard-widget--"] .table a),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget[class*="dashboard-widget--"] .table a) {
        color: #79c8ff !important;
    }
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table thead th),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget.dashboard-widget .table thead th) {
        background: var(--dashboard-table-header) !important;
        color: #b5f0d5 !important;
    }

    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .purchase-order-log__table-scroll),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .quotation-widget__table-wrap),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .change-request-widget__table-wrap),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .client-invoice-list__table-scroll),
    body.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .client-progress-claims__table-scroll),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .purchase-order-log__table-scroll),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .quotation-widget__table-wrap),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .change-request-widget__table-wrap),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .client-invoice-list__table-scroll),
    .deluxe-layout.dark .project-dashboard-page--deluxe :deep(.dashboard-widget .client-progress-claims__table-scroll) {
        background: var(--dashboard-surface) !important;
    }

    /* Keep the light-mode inherited hover colour in both themes. */
    .project-dashboard-page--deluxe :deep(.project-tracker) {
        color: #1e1b16;
    }

    .top-right-button-before {
        position: absolute; /* Positions the button absolutely within the card div */
        top: 0; /* Aligns the top of the button with the top of the card div */
        right: 20000; /* Aligns the right of the button with the right of the card div */
        z-index: 500;
    }
    .move-from-bottom { 
        opacity: 0;
        transform: translateY(100%);
        animation: moveFromBottom 1s forwards;
    }
    .card.card-round.border{
        height: inherit;
        min-height: inherit;
    }
    @keyframes moveFromBottom {
        to {
                opacity: 1;
                transform: translateY(0);
            }
    }

</style>
<script src="@/assets/projectJs/Overview.js">
</script>
